import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

//import img
import chevronDownAccent from '../../assets/icons/chevron-down-accent.svg';
import chevronDownContrast from '../../assets/icons/chevron-down-contrast.svg';
import chevronUpAccent from '../../assets/icons/chevron-up-accent.svg';
import chevronUpContrast from '../../assets/icons/chevron-up-contrast.svg';
import mailAccent from '../../assets/icons/mail-accent.svg';
import mailContrast from '../../assets/icons/mail-contrast.svg';

class StrucutreListItemContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };
    };

    toggleOpened = () => {
        const {setStructureListHeight} = this.props;

        this.setState({isOpened: !this.state.isOpened});
        setStructureListHeight();
    };

    render() {
        const {clang, label, id, shortDescription, recordsNumber, contact} = this.props;
        const {isOpened} = this.state;

        return (
            <div className="structure__list-item__content">
                <div className="structure__list-item__content--main">
                    <div className="structure__label-container">
                        <Link to={`/headings/about/details?q=*&area=all&HEADINGS[0]=${id}`} className="structure__label" title={label}>
                            <strong>{label}</strong>
                        </Link>
                        <div className="structure__count">
                           ({numberWithSpaces(!!recordsNumber ? recordsNumber : 0)})
                        </div>
                    </div>
                    {(shortDescription || contact) &&
                        <div className="structure__info">
                            {shortDescription &&
                                ((!isOpened &&
                                    <button className="structure__info__button" title={lang[clang].characteristics.field_desc} onClick={() => this.toggleOpened()}>
                                        {lang[clang].characteristics.field_desc}
                                        <img className="structure__info__button-img" src={chevronDownAccent} alt="" />
                                        <img className="structure__info__button-img contrast" src={chevronDownContrast} alt="" />
                                    </button>) ||
                                (isOpened &&
                                    <button className="structure__info__button--opened" title={lang[clang].characteristics.field_desc} onClick={() => this.toggleOpened()}>
                                        {lang[clang].characteristics.field_desc}
                                        <img className="structure__info__button-img" src={chevronUpAccent} alt="" />
                                        <img className="structure__info__button-img contrast" src={chevronUpContrast} alt="" />
                                    </button>))}
                            {contact &&
                                <a href={`mailto:${contact}`} className="structure__info__button" title={lang[clang].characteristics.contact}>
                                    {lang[clang].characteristics.contact}
                                    <img className="structure__info__button-img--contact" src={mailAccent} alt="" />
                                    <img className="structure__info__button-img--contact contrast" src={mailContrast} alt="" />
                                </a>}
                        </div>}
                </div>
                {isOpened && shortDescription &&
                    <div className="structure__info__desc" dangerouslySetInnerHTML={{__html: shortDescription}}>
                    </div>}
            </div>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(StrucutreListItemContent));



// WEBPACK FOOTER //
// ./src/components/characteristics/StrucutreListItemContent.js